var React = require('react');

function Bed (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M528 128H304a16 16 0 0 0-16 16v144h352v-48a112 112 0 0 0-112-112zM176 96a80 80 0 1 0 80 80 80 80 0 0 0-80-80z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M640 288v144a16 16 0 0 1-16 16h-32a16 16 0 0 1-16-16v-48H64v48a16 16 0 0 1-16 16H16a16 16 0 0 1-16-16V80a16 16 0 0 1 16-16h32a16 16 0 0 1 16 16v208z","className":"fa-primary","key":2})]);
}

Bed.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Bed;

Bed.default = Bed;
